/** @jsx jsx */
import { jsx } from "@emotion/react";
import { withStyles } from "@material-ui/core/styles";
import { Subject } from "rxjs";
import { AppBar, Toolbar, Typography, IconButton, InputBase } from "@material-ui/core";
import { DatePicker } from "material-ui-pickers";
import toolbarCss from "../../../../../common/styles/toolbar.css";
import datepickerCss from "../../../../../common/styles/datepicker.css";
import { ClearIcon } from "../../../../../common/components/icons";
import { Component } from "react";
import { rawUpdateListOnFilterChange } from "../../../../../common/services/FilterList";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

class PersistentEventsFilterRow extends Component {
    state = {
        searchText: "",
        searchText$: new Subject(),
    };

    componentDidMount() {
        const { getChannels, clearChannels } = this.props;
        const { searchText$ } = this.state;
        searchText$.pipe(debounceTime(500), distinctUntilChanged()).subscribe(query => {
            if (query !== "") {
                rawUpdateListOnFilterChange({
                    getFn: getChannels,
                    filter: { filter: query },
                });
            } else clearChannels();
        });
    }

    onChangeHandler = searchText => {
        const { searchText$ } = this.state;
        this.setState({ searchText: searchText }, () => searchText$.next(this.state.searchText));
    };

    render() {
        const {
            onFilterChangeHandler,
            onDateChangeHandler,
            from,
            to,
            filter,
            classes,
            labelDate = "Filter by Start Date",
        } = this.props;
        return (
            <AppBar
                position="static"
                classes={{
                    root: classes.appBarRoot,
                }}
                elevation={0}
            >
                <Toolbar
                    classes={{
                        root: classes.toolbarRootBorder,
                    }}
                >
                    <div css={toolbarCss.toolbarGroup}>
                        <Typography>
                            <span css={toolbarCss.toolbarTitle}>
                                <span css={toolbarCss.labelShowOnDesktop}>
                                    Filter by keyword or ID:
                                </span>
                                <span css={toolbarCss.labelShowOnMobile}>Filter:</span>
                            </span>
                        </Typography>
                        <InputBase
                            placeholder="..."
                            value={filter || ""}
                            onChange={onFilterChangeHandler}
                            fullWidth
                            autoComplete="off"
                        />
                    </div>
                    <div css={toolbarCss.toolbarSeparator} />
                    <div css={toolbarCss.toolbarGroup}>
                        <Typography>
                            <span css={toolbarCss.toolbarTitle}>
                                <span css={toolbarCss.labelShowOnDesktop}>{labelDate}:</span>
                                <span css={toolbarCss.labelShowOnMobile}>Date:</span>
                            </span>
                        </Typography>
                        <div css={datepickerCss.datepickerContainer}>
                            <DatePicker
                                placeholder="From..."
                                value={from !== "" ? from : null}
                                onChange={value =>
                                    onDateChangeHandler("from")(
                                        value.set({ hour: 0, minute: 0, second: 0 })
                                    )
                                }
                                fullWidth
                                autoOk={true}
                                format={"D MMM YYYY"}
                                color="primary"
                                css={toolbarCss.toolbarDatePicker}
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                            <IconButton
                                onClick={onDateChangeHandler("from", null)}
                                css={datepickerCss.datepickerBtn}
                            >
                                <ClearIcon />
                            </IconButton>
                        </div>
                        <div css={datepickerCss.datepickerContainer}>
                            <DatePicker
                                placeholder="To..."
                                value={to !== "" ? to : null}
                                onChange={value =>
                                    onDateChangeHandler("to")(
                                        value.set({ hour: 23, minute: 59, second: 59 })
                                    )
                                }
                                fullWidth
                                autoOk={true}
                                format={"D MMM YYYY"}
                                color="primary"
                                css={toolbarCss.toolbarDatePicker}
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                            <IconButton
                                onClick={onDateChangeHandler("to", null)}
                                css={datepickerCss.datepickerBtn}
                            >
                                <ClearIcon />
                            </IconButton>
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withStyles(toolbarCss)(PersistentEventsFilterRow);
